/**
 * WOPI Authentication Module
 * Handles authentication flow for WOPI environments (Office Online)
 */

import { getPolicyData } from "../services/policyService";

/**
 * Handle WOPI authentication flow
 * @returns {Object} - Authentication result
 */
export const handleWopiAuth = async () => {
  console.log("[WOPI-AUTH] Starting WOPI authentication flow...");
  
  try {
    console.log("[WOPI-AUTH] Attempting to get policy data...");
    const response = await getPolicyData();
    console.log("[WOPI-AUTH] Policy data response status:", response.status, "OK:", response.ok);

    if (response.ok) {
      console.log("[WOPI-AUTH] ✅ WOPI authentication successful");
      return {
        success: true,
        component: 'PolicyReference',
        message: 'WOPI authentication successful'
      };
    } else {
      console.log("[WOPI-AUTH] ❌ WOPI authentication failed, status:", response.status);
      return {
        success: false,
        component: 'AuthenticationError',
        statusCode: response.status,
        message: 'WOPI authentication failed'
      };
    }
    
  } catch (error) {
    console.error("[WOPI-AUTH] ❌ WOPI authentication error:", error.message);
    
    // If domain is not yet available, try to get it via dialog
    if (error.message.includes("WOPI domain not yet available")) {
      console.log("[WOPI-AUTH] 🔄 Domain not available, attempting to get via dialog...");
      
      try {
        // Import ensureTokenSetup dynamically to avoid circular dependency
        const { ensureTokenSetup } = await import('../services/policyService');
        await ensureTokenSetup();
        
        // Retry after dialog completes
        console.log("[WOPI-AUTH] 🔄 Retrying after dialog completion...");
        const retryResponse = await getPolicyData();
        
        if (retryResponse.ok) {
          console.log("[WOPI-AUTH] ✅ WOPI authentication successful after dialog");
          return {
            success: true,
            component: 'PolicyReference',
            message: 'WOPI authentication successful'
          };
        }
      } catch (dialogError) {
        console.error("[WOPI-AUTH] ❌ Dialog failed:", dialogError.message);
      }
    }
    
    return {
      success: false,
      component: 'ServiceUnavailable',
      error: error.message,
      message: 'WOPI authentication service unavailable'
    };
  }
};

/**
 * Check if WOPI environment is ready for authentication
 * @returns {boolean} - Whether WOPI is ready
 */
export const isWopiReady = () => {
  // Add any WOPI-specific readiness checks here
  return window.officeReady === true;
};

/**
 * WOPI-specific cleanup or initialization
 */
export const initializeWopi = () => {
  console.log("[WOPI-AUTH] Initializing WOPI environment...");
  // Add any WOPI-specific initialization here
};

export default {
  handleWopiAuth,
  isWopiReady,
  initializeWopi
};
